import script from "./TableCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TableCell.vue?vue&type=script&setup=true&lang=js"

import "./TableCell.vue?vue&type=style&index=0&id=19ae3975&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ae3975"]])

export default __exports__